// extracted by mini-css-extract-plugin
export default {"container":"Favorites_container__cLClM","list":"Favorites_list__da3ip","btn":"Favorites_btn__K9TT+"};